import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const Layout = styled.div`
    //  height: 200px;
    overflow: hidden;
`;

export const FloatLayout = styled.div``;

export const ColoredText = styled.span`
    color: #1010eb;
    font-size: 15px;
    font-family: 'AvenirNextWorld Demi';
`;

export const UsedText = styled.span`
    text-align: right;
    float: right;
    font-family: AvenirNextWorld Demi;
    padding: 0px 3px;
    color: #202124;
    font-size: 13px;
`;

export const ThreeText = styled.span`
    text-align: right;
    float: right;
    font-family: AvenirNextWorld Regular;
    padding: 0px 5px;
    color: #000000;
    /* font-size: 16px; */
    font-size: 13px;
    opacity: 1;
`;

export const EAText = styled.span`
    background: #ebebeb 0% 0% no-repeat padding-box;
    text-align: right;
    float: right;
    font-family: AvenirNextWorld Regular;
    padding: 0px 6px;
    color: #140f4b;
    font-size: 13px;
    opacity: 1;
    border-radius: 10px;
    width: 29px;
    height: 22px;
`;

export const LotLayout = styled.div`
    margin-bottom: 5px;
`;

export const LotText = styled.div`
    color: #140f4b;
    font-size: 13px;
    font-family: AvenirNextWorld Demi;
`;

export const LotNumber = styled.span`
    color: #140f4b;
    font-size: 13px;
    font-family: AvenirNextWorld Regular;
`;

export const Description = styled.div`
    color: #000000;
    font-size: 13px;
    font-family: AvenirNextWorld Regular;
    margin-bottom: 5px;
`;

export const DiscountLayout = styled.div`
    display: flex;
    margin-top: 10px;
    align-items: center;
`;

export const DiscountInner = styled.div`
    /* padding: 8% 9% 8% 0%; */
    width: 45%;
    /* -webkit-box-align: center;
   -ms-flex-align: center;
   -webkit-align-items: center;
   -webkit-box-align: center;
   -ms-flex-align: center; */
    align-items: center;
    /* display: -ms-grid; */
    display: flex;
    height: 100%;
    justify-content: flex-start;
`;

export const Discount = styled.div`
    color: #e5047e;
    font-size: 12px;
    font-family: AvenirNextWorld Demi;
    // margin-bottom: 5px;
    /* border: 1px solid #E5047E; */
    border-radius: 4px;
    opacity: 1;
    padding: 0px 1px;
`;

export const UnitPrice = styled.div`
    width: 33%;
    text-align: right;
`;

export const ExtPrice = styled.div`
    width: 33%;
    text-align: right;
`;

export const DemiText = styled.div`
    color: #202124;
    font-size: 13px;
    font-family: AvenirNextWorld Demi;
    opacity: 1;
`;

export const LineThroughText = styled.div`
    color: #e5047e;
    font-size: 14px;
    font-family: AvenirNextWorld Regular;
    opacity: 1;
    text-decoration: line-through;
    -webkit-text-decoration-line: line-through;
`;

export const CalculatedPrice = styled.div`
    color: #202124;
    font-size: 14px;
    font-family: AvenirNextWorld Regular;
    opacity: 1;
`;

export const UsagePriceFont = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0')};
    display: inline-block;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '13px')};
    color: ${({ color }) => (color ? color : '#000000')};
    text-decoration: ${({ textDecoration }) =>
        textDecoration ? textDecoration : 'none'};
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '0px'};
    line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : '20px')};
    opacity: 1;
`;
export const SummaryCard = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    height: 100%;
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border: none;
    border-radius: 6px;
    padding: 15px 15px;
    margin-bottom: 10px;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    ${media.mobileDevice`
    border: 1px solid #74DED6;
    margin-bottom: 15px;    
    `}
`;
